import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';

//TODO: Still need to pass the loan object array into this event for review.
export const countCellRender = (
    e: any,
    onLoanSummaryClick: (eventData: any) => void,
    shouldShowEye: (e: any) => boolean = () => true
) => {
    const count = e.value;

    if (count < 1) {
        return <span>-</span>;
    }

    const showEye = shouldShowEye(e);

    return (
        <>
            <span style={{ paddingRight: '10px' }}>{count}</span>

            {showEye && (
                <FontAwesomeIcon
                    icon={faEye}
                    style={{ color: 'darkblue', cursor: 'pointer' }}
                    onClick={() => onLoanSummaryClick(e)}
                />
            )}
        </>
    );
};
